import React, { useEffect } from 'react';
import {Button} from 'react-bootstrap';
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";

const Table = ({ columns, data, search, intl, pageSize }) => {
  // Use the state and functions returned from useTable to build your UI
  const {
    prepareRow,
    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex },
    setGlobalFilter,
  } = useTable({
    columns,
    data,
    manualSortBy: true,
    disableSortBy: true,
    autoResetSortBy: false,
  }, useGlobalFilter, useSortBy, usePagination);

  useEffect(() => {
    setGlobalFilter(search);
  }, [search, setGlobalFilter]);

  useEffect(() => {
    setPageSize(pageSize? pageSize : 6);
  }, [pageSize, setPageSize]);

  // Render the UI for your table
  return (
    <React.Fragment>
      <div className="events-container">
        {page.map((row, i) => {
          prepareRow(row)
          return (
            <div {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <div {...cell.getCellProps()}>{cell.render('Cell')}</div>
              })}
            </div>
          )
        })}
      </div>
      <div style={{opacity: pageSize ? 0:1}} className="text-center pagination justify-content-center">
        <Button variant="link" onClick={() => previousPage()} disabled={!canPreviousPage}>
          <img src="/icons/arrow-left.png" alt="" />
        </Button>
        <span style={{ marginTop: '8px' }}>{pageIndex + 1} / {pageOptions.length}</span>
        <Button variant="link" onClick={() => nextPage()} disabled={!canNextPage}>
          <img src="/icons/arrow-right.png" alt="" />
        </Button>
      </div>
    </React.Fragment>
  )
}

export default Table;